export default __webpack_public_path__ + "static/media/mega_sale.f156594a.png";